import React from "react";
import MyInput from "../MyInput";
import { MySkeleton } from "./MySkeleton";

export default function IndentPOSkeleton() {
  return (
    <div className="mt-12">
      <div className="px-2 w-full mb-2">
        <form> 
          <div className="grid grid-cols-2 gap-x-2 md:grid-cols-4">
            <div className="grid grid-cols-2 gap-x-2 md:grid-cols-4">
              <span className="px-0.5 py-2 rounded-full">
                <MySkeleton width="30px" height="15px" />
              </span>
              <span className="px-0.5 py-2 rounded">
                <MySkeleton width="60px" height="15px" />
              </span>
              <span className="px-0.5 py-2 rounded">
                <MySkeleton width="60px" height="15px" />
              </span>
              <span className="px-0.5 py-2 rounded">
                <MySkeleton width="50px" height="15px" />
              </span>
              <span className="font-bold px-0.5 py-2 rounded">
                <MySkeleton width="60px" height="15px" />
              </span>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
